// extracted by mini-css-extract-plugin
export default {"container":"style_container__9BPzI","header":"style_header__upqZp","content":"style_content__VYzvg"};